import React, { FunctionComponent } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { View } from 'react-native'

import styled from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Link } from '../../atoms/link/Link'
import { PrimaryButton } from '../../atoms/primaryButton/PrimaryButton'
import { Title, Size as TitleSize } from '../../atoms/title/Title'
import { Modal } from '../../organisms/modal/Modal'
import { openUrl } from '../../utils/expo-linking'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export type DAInvoiceFailedModalProps = {
  visible: boolean
  onRequestClose: () => void
  clientName: string
  sessionNumber?: string | number
  supportUrl?: string
}

const InvoiceCTAContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  marginTop: spacing['24px'],
}))

const HeaderContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  marginBottom: spacing['16px'],
}))
export const DAInvoiceFailedModal: FunctionComponent<DAInvoiceFailedModalProps> = ({
  visible,
  onRequestClose,
  clientName,
  sessionNumber,
  supportUrl = 'https://provider-support.lyrahealth.com/hc/en-us/requests/new',
}) => {
  const { formatDate } = useIntl()
  return (
    <Modal
      visible={visible}
      onRequestClose={onRequestClose}
      modalContents={
        <View>
          <HeaderContainer>
            <Title
              size={TitleSize.LARGE}
              text={
                <FormattedMessage
                  defaultMessage='Invoice submission failed'
                  description='DA invoice failed modal title'
                />
              }
            />
          </HeaderContainer>
          <BodyText
            text={
              <FormattedMessage
                defaultMessage="We couldn't process the invoice for your session with {clientName}. To resolve this, please <supportLink>submit a support ticket</supportLink> with the details below:"
                description='DA invoice failed modal body with inline support link'
                values={{
                  clientName,
                  supportLink: (chunks: React.ReactNode) => (
                    <Link text={chunks as string} onPress={() => openUrl(supportUrl)} underline />
                  ),
                }}
              />
            }
          />
          <BodyText
            text={
              <FormattedMessage
                defaultMessage='• {clientName}'
                description='Client name bullet'
                values={{ clientName }}
              />
            }
          />
          <BodyText
            text={
              <FormattedMessage
                defaultMessage='• Session {sessionNumber}'
                description='Session number bullet'
                values={{ sessionNumber }}
              />
            }
          />
          <BodyText
            text={
              <FormattedMessage
                defaultMessage='• {submissionDateText}'
                description='Submission date bullet'
                values={{
                  submissionDateText: formatDate(new Date(), { month: 'long', day: 'numeric', year: 'numeric' }),
                }}
              />
            }
          />
          <InvoiceCTAContainer>
            <PrimaryButton
              testID={tID('DAInvoiceFailedModal-CTA')}
              text={
                <FormattedMessage
                  defaultMessage='Got it'
                  description='Dismiss button label in DA invoice failed modal'
                />
              }
              onPress={onRequestClose}
            />
          </InvoiceCTAContainer>
        </View>
      }
    />
  )
}
